import { render, staticRenderFns } from "./AppBoot.vue?vue&type=template&id=bf2bc874&scoped=true&"
import script from "./AppBoot.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppBoot.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2bc874",
  null
  
)

export default component.exports